import { render } from "./RecordPaidPaymentForm.vue?vue&type=template&id=762d8855"
import script from "./RecordPaidPaymentForm.vue?vue&type=script&lang=js"
export * from "./RecordPaidPaymentForm.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__